<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div class="unbranded-loader">
    <div class="veil" />
    <div class="loader-container">
      <canvas
        ref="canvasLoader"
        class="canvas-loader" />
      <span>
        {{ message }}
      </span>
    </div>
  </div>
</template>

<script type="text/babel">
  import i18n from '@/vueI18n';

  export default {
    props: {
      message: {
        type: String,
        default: () => i18n.global.t('states.loading'),
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.initializeCanvas();
      });
    },
    methods: {
      initializeCanvas() {
        const canvas = this.$refs.canvasLoader;
        const d = 64;
        canvas.width = d;
        canvas.height = d;
        const ctx = canvas.getContext('2d');
        let opacity = 0;

        ctx.translate(d / 2, d / 2);
        ctx.rotate(Math.PI);
        ctx.lineWidth = 2;
        ctx.lineCap = 'square';

        for (let i = 0; i <= 360; i += 1) {
          ctx.save();

          ctx.rotate(Math.PI * (i / 180));

          ctx.beginPath();
          ctx.moveTo(0, 0);
          opacity = (360 - i * 0.95) / 360;
          ctx.strokeStyle = `rgba(102,102,102,${opacity.toFixed(2)})`;
          ctx.lineTo(0, d + 30);
          ctx.stroke();
          ctx.closePath();

          ctx.restore();
        }

        ctx.globalCompositeOperation = 'source-out';
        ctx.beginPath();
        ctx.arc(0, 0, d / 2, 2 * Math.PI, false);
        ctx.fillStyle = '#666666';
        ctx.fill();

        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath();
        ctx.arc(0, 0, (d / 2) * 0.9, 2 * Math.PI, false);
        ctx.fill();
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .unbranded-loader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100000;

    .veil {
      background: #000;
      opacity: 0.01;
      width: 100vw;
      height: 100vh;
      pointer-events: none;
    }
    .loader-container {
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -60px 0 0 -60px;
      display: flex;
      align-items: center;
      background: #fff;
      padding: 2.4rem 3.2rem;
      border-radius: 1.6rem;
      box-shadow: $light-shadow;
    }

    span {
      margin-left: 1.6rem;
    }

    .canvas-loader {
      -webkit-animation: spin 1s infinite cubic-bezier(0.7, 0.4, 0.5, 0.7);
      width: 3.2rem;
      height: 3.2rem;
    }

    @-webkit-keyframes spin {
      to {
        -webkit-transform: translateZ(0) rotate(360deg);
      }
    }
  }
</style>
